import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import { Children, type HTMLProps, type PropsWithChildren } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface LegalSectionProps extends HTMLProps<HTMLElement> {
  readonly header: MessageKey;
  readonly useH1Element?: boolean;
  readonly useH1Variant?: boolean;
}

const LegalSection = ({
  className,
  children,
  header,
  useH1Element = false,
  useH1Variant = false,
  ...props
}: PropsWithChildren<LegalSectionProps>) => {
  const t = useTranslations();

  const headerElement = useH1Element ? 'h1' : 'h2';
  const headerVariant = useH1Variant ? 'h1' : 'h3';
  const hasChildren = Children.toArray(children).some((child) =>
    Array.isArray(child) ? child.length : Boolean(child),
  );

  return (
    <section
      className={cx(
        'space-y-4',
        {
          'mb-10': hasChildren,
          'mb-8': !hasChildren,
        },
        className,
      )}
      data-cy="legal-section"
      {...props}
    >
      <Typography
        Element={headerElement}
        data-cy="legal-header"
        variant={headerVariant}
      >
        {t(header)}
      </Typography>
      {children}
    </section>
  );
};

export default LegalSection;
